export default {
  props: {
    background: {
      type: Boolean,
      default: false
    },
    bottom: {
      type: Boolean,
      default: true
    }
  }
};